module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/38ac2210b486d930f72c951ad081e4c0.svg";